import { Button, styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const CloseButton = styled(Button)(({ theme }) => ({
  minWidth: 30,
  width: 30,
  height: 30,
  padding: 0,
  borderRadius: '99px',
  color: theme.palette.text.secondary,
  backgroundColor: '#f2f5f9',
  ...theme.applyStyles('dark', { backgroundColor: theme.palette.action.hover }),
}));

/** Bordered container holding the pack summary and the quantity stepper. */
